module.exports = __webpack_public_path__ + "img/play-button.2570236e.svg";